import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'Do you provide web application services?',
    a: 'We provide application development services to all sorts of business requirements and needs. We have well experienced developers with the necessary skills to perform the task.',
  },
  {
    q: 'How does virtual assistance work?',
    a: 'Virtual Assistance is a profession by companies with employed individuals who work dedicatedly to their clients. The professionals are called Virtual Assistants. Virtual Assistants are business owners who provide administrative and personal support for clients across the globe using phone, fax, email and other facilities.',
  },
  {
    q: 'What will be the turn-around time of medical transcription services?',
    a: 'General transcription of charts will be available for your review/printing before 9 AM the following day, which is less than 24 hours turn-around time.',
  },
  {
    q: 'Do you sub-contract our transcription work?',
    a: 'No, all your transcription is handled in-house at our office and hence we have better security measures and better control over patient information been implemented at all levels of work.',
  },
  {
    q: 'Do you have any billing system for various medical specialties?',
    a: 'Yes, We handle all types of billing systems that could accommodate your medical specialties like ambulance services, medical equipments and physician\'s specialties as well.',
  },
  {
    q: 'Do you provide software consulting?',
    a: 'We offer a complete range of software consulting services that will surely aid you in making timely decisions to implement solutions for business requirements and processing. We have well qualified and experienced professionals with industry specific domain knowledge to offer consulting services. We also offer services to all types of industries of small, medium and large companies.',
  },
  {
    q: 'What if I still have questions?',
    a: 'If you cannot find the appropriate answer, please feel free and do not hesitate to contact us. We will be happy to provide any information that is required by you, which helps in quick and concrete decision making.',
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(null);

  return (
    <>
      <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
        <div className="container py-4">
          <h1 className="fw-bold">Frequently Asked Questions</h1>
          <p className="lead" style={{ color: '#cbd5e1' }}>Find answers to the most common questions about our services</p>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9">
              {faqs.map((faq, i) => (
                <div key={i} className="card border-0 shadow-sm rounded-4 mb-3">
                  <button
                    className="btn w-100 text-start p-4 d-flex justify-content-between align-items-center"
                    onClick={() => setOpen(open === i ? null : i)}
                    style={{ background: 'none', border: 'none' }}
                  >
                    <span className="fw-bold" style={{ color: '#1a56db' }}>
                      {i + 1}. {faq.q}
                    </span>
                    <span className="ms-3 flex-shrink-0" style={{ fontSize: 20, color: '#1a56db' }}>
                      {open === i ? '−' : '+'}
                    </span>
                  </button>
                  {open === i && (
                    <div className="px-4 pb-4">
                      <p className="text-muted mb-0" style={{ lineHeight: 1.9 }}>{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}

              <div className="text-center mt-5">
                <p className="text-muted mb-3">Still have questions? We're here to help.</p>
                <Link to="/contact" className="btn btn-primary btn-lg fw-bold px-5">Contact Us →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
